import { apiSlice } from '../../api';
import type {
  GetDepositInvoicesDTO,
  GetDepositInvoicesResult,
  GetSessionDTO,
  GetSessionResult,
} from './types';

const adminGeneralEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getSession: build.query<GetSessionResult, GetSessionDTO>({
      query: () => ({
        url: '/admin/v1/whoami',
        method: 'GET',
      }),
    }),

    getDepositInvoices: build.query<GetDepositInvoicesResult, GetDepositInvoicesDTO>({
      query: ({ params }) => ({
        url: '/admin/v1/wallet-deposit-invoices',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useLazyGetSessionQuery } = adminGeneralEndpoints;
export const { useLazyGetDepositInvoicesQuery } = adminGeneralEndpoints;

export type AdminGeneralController = typeof adminGeneralEndpoints;
